import { render } from "./AdministrateSimulatorsComponent.vue?vue&type=template&id=8fbb0da0"
import script from "./AdministrateSimulatorsComponent.vue?vue&type=script&lang=js"
export * from "./AdministrateSimulatorsComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__